import { useEffect } from 'react'
import { useAccount } from '../../../hooks/useAccount'
import { usePopUpMembershipStore } from '../../account/stores/pop-up-membership-store'
import { useAnnouncementStore } from './use-announcement-store'

export const useAnnouncements = () => {
  const { isLogin, token, account } = useAccount()
  const { popupShown } = usePopUpMembershipStore()

  const { list, active, fetchAll, dismiss, resolveNext, setAccountId } =
    useAnnouncementStore()

  // 🔥 Reset storage + reset zustand state ketika logout
  useEffect(() => {
    if (!isLogin) {
      localStorage.removeItem('announcement-storage')

      useAnnouncementStore.setState({
        list: [],
        active: null,
        currentActiveId: null,
        shownIds: [],
        accountId: null,
      })
    }
  }, [isLogin])

  // Set user ID (untuk grouping session per user)
  useEffect(() => {
    setAccountId(account?.id || null)
  }, [account, setAccountId])

  // Fetch announcement ketika login
  useEffect(() => {
    if (isLogin && token) {
      fetchAll(token)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLogin, token])

  // Resolve next ketika list berubah (tidak tergantung popupShown lagi)
  useEffect(() => {
    resolveNext()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list])

  const handleDismiss = async () => {
    if (!active) return
    await dismiss(active.id, token || null)

    resolveNext()
  }

  return {
    active,
    dismiss: handleDismiss,
    list,
  }
}
